module.exports = __webpack_public_path__ + "img/dislike.1fe9d90f.svg";